import { buildProps } from '../../../utils/vue/props/runtime.mjs';
import { isArray } from '@vue/shared';

const uploadDraggerProps = buildProps({
  disabled: Boolean
});
const uploadDraggerEmits = {
  file: (file) => isArray(file)
};

export { uploadDraggerEmits, uploadDraggerProps };
//# sourceMappingURL=upload-dragger.mjs.map
